import {WalletContext} from '#/contexts/wallet-provider';
import {FunctionComponent, useContext, useState} from 'react';

export const CopyAddressToClipboardButton: FunctionComponent = () => {
  const {
    accountResult: {address},
  } = useContext(WalletContext);

  const [addressCopied, setAddressCopied] = useState(false);

  const onClick = async () => {
    if (!address) {
      return;
    }

    await navigator.clipboard.writeText(address);
    setAddressCopied(true);
  };

  return (
    <button
      className={
        'w-full bg-deepblue text-white flex gap-2 justify-center items-center py-1 px-2 overflow-hidden rounded hover:opacity-70 disabled:hover:opacity-100 disabled:bg-upgreen disabled:cursor-not-allowed'
      }
      onClick={onClick}
      disabled={addressCopied}
    >
      <span className='grow'>{!addressCopied ? 'Copy Address' : 'Address Copied!'}</span>
    </button>
  );
};
